import TutorialPage from "./tutorial-page"

export const OfficeManagerTutorialPage = () => {


    return (
        <TutorialPage variant='office-manager' />
    )

}